/**
 * Created by meikang on 2019/3/7.
 * io服务
 */
import Vue from 'vue'
import store from './store'
import base from './base'
import io from 'socket.io-client'

let socket = null, gameData = store.state.gameData;

class Socket {
    constructor() {
        this.url = "";
        this.serveKey = null; //当前游戏服务key--ZZ\CC
        this.timer = null; //定时器ID
        this.errConfig = {
            1: '嘟币不足',
            2: '不是押注时间',
            3: '错误的投注id',
            4: '错误的嘟币数',
            5: '参与人数达到上线',
            6: '未知错误、请稍后尝试！',
            7: '主播不能押注',
            8: '用户的财富星级受限'
        };
    }

    static config(key) {
        const config = {
            ZZ: { //转转配置
                /*store.state.token = 1542308617; store.state.uid = 21001841;*/
                url: 'http://211.159.201.7:10210/zhuanzhuan'
            },
            CC: { //猜猜配置
                url: 'http://211.159.201.7:10211/caicai'
            }
        };

        return config[key] || {};
    }

    /*
    * @brief 更新游戏数据
    * */
    static updateGameData(data) {
        gameData.state = data.dwStage;
        gameData.time = data.dwCurStageLeftTime;
        gameData.totalTime = data.dwCurStageTotalTime;
    }

    /*
    * @brief 更新投注区数据
    * */
    static updateBetData(data) {
        gameData.totalCoin = data.dwTotalCoin || [];
        gameData.totalPlayer = data.dwTotalPlayer || [];
    }

    /*
    * @brief io获取事件处理
    * */
    ioEmit(key, data, fun) {
        let d;
        switch (key) {
            /*---------------------------------------- 公共类 ----------------------------------------*/
            case 'getUserLever': //获取用户财富等级信息
                d = {cmd:"dudu.activityserver.ReqActivityUserInfoNode", json:{ userid: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {
                    console.log(res, '---------------获取用户财富等级信息');
                });
                break;

            case 'getMoney': //获取用户金币
                d = { cmd:"dudu.billserver.QueryUserDuduCoin", json:{ userid: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {
                    store.state.money = res.data.dwCurCoin;
                });
                break;

            case 'getUserProp': //获取用户道具
                d = { cmd:"dudu.packetserver.QueryPackageInfo", json:{ userid: store.state.uid, packageid: data.propId }};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data) gameData.propData = gameData.propData.concat(res.data.data || []);
                });
                break;

            case 'getUserPropArr': //获取多个用户道具
                d = { cmd:"dudu.userpackageserver.QueryPackageArryInfo", json:{ userid: store.state.uid, packageinfo: gameData.propId }};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data) gameData.propData = gameData.propData.concat(res.data.data || []);
                    console.log(res, '-----------获取多个用户道具');
                });
                break;

            /*---------------------------------------- 转转 ----------------------------------------*/
            case 'getUserName': //获取用户昵称
                d = {cmd:"dudu.gameappserver.RequestUserGameNameNode", json:{ dwUserId: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {

                });
                break;

            case 'gameUpdateData': //同步游戏状态
                d = {cmd:"dudu.gameappserver.GetGameStageNode", json:{}};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data && res.data.marjor == 31 && res.data.minjor == 2) {
                        Socket.updateGameData(res.data);
                        if(res.data.dwStage == 101) this.startTime();
                        base.event.trigger('noticeGame', 'openAward', res.data);
                    }
                });
                break;

            case 'getBetInfo': //获取当前局赔率列表
                d = {cmd:"dudu.gameappserver.RequestGiftInfoListNode", json:{}};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data) {
                        gameData.scale = res.data.dwScale || [];
                        gameData.scaleNext = res.data.dwScaleNext || [];
                    } else console.log('-----------------------获取当前局赔率列表出错', res);
                });
                break;

            case 'bottomPour': //请求下注
                d = {cmd:"dudu.gameappserver.RequestBetNode", json:{ dwUserId: store.state.uid, dwItemId: data.itemId, dwCoinNum: data.money * 100 }};
                socket.emit('dudu.msg', d, (res) => {
                    let str;
                    if(res.data.dwBetState == 0) {
                        store.state.money -= res.data.dwCoinNum; //记录当前金币
                        const money = (gameData.myCoin[data.itemId] || 0) + res.data.dwCoinNum;
                        Vue.set(gameData.myCoin, data.itemId, money);
                    } /*else str = this.errConfig[res.data.dwBetState] || '未知错误、请稍后尝试！';
                    if(typeof fun === 'function' && str) fun(str);*/
                });
                break;

            case 'getBottomPourInfo': //请求下注数据
                d = {cmd:"dudu.gameappserver.RequestBetInfoListNode", json:{ dwUserId: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data && res.data.dwCoinNum) gameData.myCoin = res.data.dwCoinNum || gameData.myCoin;
                });
                break;

            case 'useProp': //请求使用嘟币劵下注
                d = {
                    cmd:"dudu.gameappserver.RequestBetByCardNode",
                    json:{
                        dwUserId: store.state.uid,
                        dwItemId: data.itemId,
                        dwCoinNum: data.money * 100,
                        dwCardType: data.propId,
                        dwCount: 1
                    }
                };
                socket.emit('dudu.msg', d, (res) => {
                    let str;
                    if(res.data.dwBetState == 0) {
                        store.state.money -= res.data.dwCoinNum / 2; //记录当前金币
                        const money = (gameData.myCoin[data.itemId] || 0) + res.data.dwCoinNum;
                        Vue.set(gameData.myCoin, data.itemId, money);
                        const d = gameData.propData.find(item => item.dwPackageId == data.propId);
                        if(d) d.dwPackageNum -= 1;
                    } /*else str = this.errConfig[res.data.dwBetState] || '未知错误、请稍后尝试！';
                    if(typeof fun === 'function' && str) fun(str);*/
                });
                break;

            case 'awardRecord': //请求自己的中奖记录
                d = {cmd:"dudu.gameappserver.RequestLastAwardRecordListNode", json:{ dwUserId: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {
                    gameData.historyRecord = (res.data || {}).data || [];
                });
                break;

            /*---------------------------------------- 猜猜 ----------------------------------------*/
            case 'noticeGameOpen': //通知用户上线
                d = {cmd:"dudu.gameappserver.NotifyUserOpenGameNodeCaiCai", json:{ dwUserId: store.state.uid, dwOpType:1 }};
                socket.emit('dudu.msg', d, () => {});
                break;

            case 'getGameName': //请求游戏昵称
                d = {cmd:"dudu.gameappserver.ReqGmaeNickNameNodeCaiCai", json:{ dwUserId: store.state.uid }};
                break;

            case 'militaryExploits': //请求战绩
                d = {cmd:"dudu.gameappserver.ReqUserRecordNodeCaiCai", json:{ dwUserId: store.state.uid }};
                socket.emit('dudu.msg', d, () => {
                    if(res.data) base.event.trigger('noticeGame', 'militaryExploits', res.data.dwRecord || 0);
                });
                break;

            case 'getGameState': //请求游戏状态
                d = {cmd:"dudu.gameappserver.ReqGmaeStageNodeCaiCai", json:{ dwUserId: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data) {
                        Socket.updateGameData(res.data);
                        if(res.data.dwStage == 101) this.startTime();
                        base.event.trigger('noticeGame', 'openAward', res.data);
                    }
                });
                break;

            case 'getUserBetInfo': //请求个人下注信息
                d = {cmd:"dudu.gameappserver.ReqBetInfoListNodeCaiCai", json:{ dwUserId: store.state.uid }};
                socket.emit('dudu.msg', d, (res) => {
                    if(res.data && res.data.dwCoinNum) gameData.myCoin = res.data.dwCoinNum || gameData.myCoin;
                });
                break;

            case 'getGameRecord': //请求历史中奖纪录
                d = {cmd:"dudu.gameappserver.ReqRecentNSelectedItemNodeCaiCai", json:{ }};
                socket.emit('dudu.msg', d, (res) => {
                    gameData.historyRecord = (res.data || {}).data || [];
                });
                break;

            case 'gameBetOnMoney': //游戏嘟币押注
                d = {cmd:"dudu.gameappserver.RequestBetNodeCaiCai", json:{ dwUserId: store.state.uid, dwItemId: data.itemId, dwCoinNum: data.money * 100 }};
                socket.emit('dudu.msg', d, (res) => {
                    console.log('-------------游戏嘟币押注', res);
                    let str;
                    if(res.data.dwBetState == 0) {
                        store.state.money -= data.money * 100; //记录当前金币
                        const money = (gameData.myCoin[data.itemId] || 0) + data.money * 100;
                        Vue.set(gameData.myCoin, data.itemId, money);
                    } /*else str = this.errConfig[res.data.dwBetState] || '未知错误、请稍后尝试！';
                    if(typeof fun === 'function' && str) fun(str);*/
                });
                break;

            case 'gameBetOnProp': //游戏道具押注
                d = {cmd:"dudu.gameappserver.RequestBetByCardNodecCaiCai", json:{ dwUserId: store.state.uid, dwItemId: data.itemId,
                        dwCoinNum: data.money * 100, dwCardType: data.propId, dwCount: 1 }};
                socket.emit('dudu.msg', d, (res) => {
                    let str;
                    if(res.data.dwBetState == 0) {
                        store.state.money -= data.money * 100; //记录当前金币
                        const money = (gameData.myCoin[data.itemId] || 0) + data.money * 100;
                        Vue.set(gameData.myCoin, data.itemId, money);
                        const d = gameData.propData.find(item => item.dwPackageId == data.propId);
                        if(d) d.dwPackageNum -= 1;
                    } /*else str = this.errConfig[res.data.dwBetState] || '未知错误、请稍后尝试！';
                    if(typeof fun === 'function' && str) fun(str);*/
                });
                break;

        }
    }

    /*
    * @brief 转转连接成功
    * */
    connectZZ() {
        this.ioEmit('getBetInfo');
        this.ioEmit('gameUpdateData');
        this.ioEmit('awardRecord');
        this.ioEmit('getMoney');
        this.ioEmit('getBottomPourInfo');
        this.ioEmit('getUserLever');
        this.ioEmit('getUserPropArr');
    }

    /*
    * @brief 猜猜连接成功
    * */
    connectCC() {
        this.ioEmit('noticeGameOpen');
        this.ioEmit('getMoney');
        this.ioEmit('getGameState');
        this.ioEmit('getGameRecord');
        this.ioEmit('getUserBetInfo');
        this.ioEmit('getUserPropArr');
    }


    /*
    * @brief 定时器
    * */
    startTime() {
        if(gameData.time) {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                gameData.time -= 1;
                if(gameData.time == 0) clearInterval(this.timer);
            }, 1000);
        }
    }

    /*
    * @brief socket.io初始化
    * */
    initServe() {

        if(socket) return;

        const url = Socket.config(this.serveKey).url + '?uid=' + store.state.uid + '&token=' + store.state.token;

        console.log("----------【进入socket.io通信处理】", url);

        socket = io(url, { 'transports': ["websocket"] });

        socket.on('connect', () => {
            store.state.ioStatus = null;
            if(this.serveKey === 'ZZ') this.connectZZ();
            if(this.serveKey === 'CC') this.connectCC();
            console.log("----------------------------connect：连接成功");
        });
        socket.on('disconnect', () => {
            store.state.ioStatus = '断开连接';
            console.log("----------------------------disconnect：断开连接");
        });
        socket.on('connect_failed', () => {
            console.log("----------------------------connect_failed：连接失败");
        });
        socket.on('reconnect_failed', () => {
            console.log("----------------------------reconnect_failed：重连失败");
        });
        socket.on('reconnecting', (e) => {
            store.state.ioStatus = '正在重连...';
            console.log("----------------------------reconnecting：正在重连", e);
        });
        socket.on("reconnect", () => {
            store.state.ioStatus = '成功重连';
            console.log('----------------------------reconnect：成功重连');
        });
        socket.on('error', (res) => {
            //socket.close();
            //socket = null;
            store.state.ioStatus = res;
            console.log("----------------------------error：连接错误", res);
        });

        /*
        * @brief 接收服务器数据推送
        * */
        socket.on('evBrocast', (data) => {
            data = data || {};
            const key = data.marjor + '_' + data.minjor;
            console.log('----------------接收服务器数据推送', key);
            switch (key) {
                /*---------------------------------------- 转转 ----------------------------------------*/
                case '31_2': //游戏阶段信息变更
                    Socket.updateGameData(data);
                    if(data.dwStage == 101) { //开始阶段
                        this.ioEmit('getMoney'); //更新用户嘟币
                        gameData.scale = gameData.scaleNext;
                        gameData.myCoin = [];
                        gameData.awardList = [];
                        Socket.updateBetData({});
                        this.startTime();
                    }
                    base.event.trigger('noticeGame', 'openAward', data);
                    break;

                case '31_4': //倍率列表变化
                    gameData.scale = data.dwScale;
                    gameData.scaleNext = data.dwScaleNext;
                    break;

                case '31_7': //投注区数据
                    Socket.updateBetData(data);
                    break;

                case '31_8': //用户中奖信息通知
                    base.event.trigger('noticeGame', 'openAwardResult', data);
                    break;

                case '31_9': //每轮中奖名单
                    console.log(data, '----------------------每轮中奖名单');
                    gameData.awardList = data.data || [];
                    break;

                case '31_11': //单播用户下注信息
                    //console.log(data, '----------------------单播用户下注信息');
                    gameData.myCoin = data.dwCoinNum || gameData.myCoin;
                    break;

                case '31_18': //用户道具信息通知
                    if(data.data) {
                        const arr = data.data || [];
                        for(let i = 0; i < arr.length; i ++) {
                            const d = gameData.propData.find(item => item.dwPackageId == arr[i].dwPackageType);
                            if(d) d.dwPackageNum = arr[i].dwPackageNum;
                        }
                    }
                    break;

                /*---------------------------------------- 猜猜 ----------------------------------------*/
                case '31_21': //游戏状态
                    Socket.updateGameData(data);
                    if(data.dwStage == 101) { //开始阶段
                        this.ioEmit('getMoney'); //更新用户嘟币
                        gameData.myCoin = [];
                        gameData.awardList = [];
                        Socket.updateBetData({});
                        this.startTime();
                    }
                    base.event.trigger('noticeGame', 'openAward', data);
                    break;

                case '31_37': //中奖榜单
                    break;

                case '31_38': //游戏下注信息
                    const _d = {dwTotalCoin: [], dwTotalPlayer: []}, arr = data.data || [];
                    for(let i = 0; i < arr.length; i ++) {
                        _d.dwTotalCoin[arr[i].dwItemId] = arr[i].dwCoinNum;
                        _d.dwTotalPlayer[arr[i].dwItemId] = arr[i].dwPlayerNum;
                    }
                    Socket.updateBetData(_d);
                    break;

                case '31_32': //用户下注消息
                    console.log('--------------------用户下注消息', data);
                    gameData.myCoin = data.dwCoinNum || gameData.myCoin;
                    break;

                case '31_30': //用户战绩
                    base.event.trigger('noticeGame', 'militaryExploits', data.dwRecord || 0);
                    break;

                case '31_39': //用户中奖信息
                    console.log('---------------------用户中奖信息', data);
                    base.event.trigger('noticeGame', 'openAwardResult', data);
                    break;

            }

        });

    }

    /*
    * @brief 游戏服务初始化
    * */
    initGame() {
        const uid = base.getUrlParam('uid'), token = base.getUrlParam('token'), webView = base.getUrlParam('webView');
        if(uid && token) {
            store.state.token = parseInt(token, 10);
            store.state.uid = parseInt(uid, 10);
            store.state.webView = webView || 'finde';
            this.serveKey = webView === 'game2' ? 'CC' : 'ZZ';
            store.state.test = "-------游戏初始化uid:" + uid + '------token:' + token;
            this.initServe();
        }
        console.log("--------------游戏初始化uid:" + uid + '------token:' + token);
    }
}

const $socket = new Socket();

window.cc = $socket;

/*
* @brief 提供本地测试入口
* */
window.initGame = (info) => {
    const uid = info.uid, token = info.token, webView = info.webView;
    if(uid && token) {
        store.state.token = parseInt(token, 10);
        store.state.uid = parseInt(uid, 10);
        store.state.webView = webView || 'finde';
        $socket.serveKey = webView === 'game2' ? 'CC' : 'ZZ';
        $socket.initServe();
    }
    console.log("--------------游戏初始化uid:" + uid + '------token:' + token);
};

export default $socket;
